export enum FormControlConfigType {
  String = 'string',
  Boolean = 'boolean',
  Enum = 'enum',
  EnumList = 'enumList',
}
